// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.viewer .sk-tooltip__text {\n  top: 35px;\n  width: auto;\n  padding: 10px 15px;\n  border-radius: 10px;\n  background-color: #fff;\n  color: #333;\n  -webkit-box-shadow: 0 0 9px 0 rgba(0, 34, 102, 0.3);\n          box-shadow: 0 0 9px 0 rgba(0, 34, 102, 0.3);\n}\n", ""]);
// Exports
module.exports = exports;
